import React, {Component} from "react";
import applogic from "../applogic.js";
import ModuleVideoList from "./ModuleVideoList.js";
import {connect} from "react-redux";

class OpenModule extends Component {
    static compare(a, b) {
        let ayear = a.props.mod.CourseAcadYear;
        let byear = b.props.mod.CourseAcadYear;
        if (ayear === byear) {
            let aname = a.props.mod.CourseCode.toUpperCase();
            let bname = b.props.mod.CourseCode.toUpperCase();
            if (aname === bname) {
                let asem = a.props.mod.CourseSemester.toUpperCase();
                let bsem = b.props.mod.CourseSemester.toUpperCase();
                return asem > bsem ? 1 : asem < bsem ? -1 : 0;
            } else {
                return aname > bname ? 1 : aname < bname ? -1 : 0;
            }
        } else {
            return ayear < byear ? 1 : ayear > byear ? -1 : 0;
        }
    }
    componentDidMount() {
        window.$(this.moduleList).click(applogic.handleOpenModuleClick.bind(null, this.props.mod, this.moduleList));
    }
    render() {
        let id = this.props.collapseId;
        let classes = 'collapse ' + (this.props.collapse[id] ? 'show' : '');
        return (
            <div className="card" ref={moduleList => this.moduleList = moduleList}>
                <div className="card-header">
                    <h5 className="module-title-h5 mb-0">
                        <a data-toggle="collapse" href={'#' + id} aria-controls={id} aria-expanded="false">
                            {this.props.mod.CourseAcadYear + ' ' + this.props.mod.CourseSemester}
                            &nbsp;- {this.props.mod.CourseCode} - {this.props.mod.CourseName}
                        </a>
                        {this.props.isSearchResult && <span className="badge badge-info">Searched result</span>}
                    </h5>
                </div>
                <div id={id} className={classes}>
                    <div className="card-block">
                        <ModuleVideoList moduleVideoList={this.props.mod.moduleVideoList} midx={id}/>
                    </div>
                </div>
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        collapse: state.collapse
    };
};
export default connect(mapStateToProps)(OpenModule);


// WEBPACK FOOTER //
// ./src/componentsBody/OpenModule.js